<template>
  <div class="login-page">
    <div class="layer bg" id="login"></div>
    <div class="layer flex-center">
      <!-- logo部分 -->
      <div class="logo-group">
        <img src="./image/logo.png" alt="logo">
      </div>
      <!-- 表单部分 -->
      <div class="form-group" style="margin-top:100px">
        <el-card>
          <el-form ref="loginForm" label-position="top" :rules="rules" :model="formLogin" size="default">
            <el-form-item prop="username">
              <el-input type="text" v-model="formLogin.username" placeholder="用户名">
                <i slot="prepend" class="fa fa-user-circle-o">账户</i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="formLogin.password" placeholder="密码">
                <i slot="prepend" class="fa fa-keyboard-o">密码</i>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input type="text" v-model="formLogin.code" placeholder="- - - -" @keyup.enter.native="submit">
                <template slot="prepend">验证码</template>
                <template slot="append">
                  <img class="login-code" :src="codeUrl" @click="getCode">
                </template>
              </el-input>
            </el-form-item>
            <el-button-group>
              <el-button size="default" @click="submit" type="primary">登录</el-button>
            </el-button-group>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
require("particles.js");
import config from "./config/default";
import { mapActions } from "vuex";
import { getCodeImg } from "@/api/sys/login"
export default {
  data() {
    return {
      // 快速选择用户
      dialogVisible: false,
      codeUrl: './image/login-code.png',
      users: [
        {
          name: "超级管理员",
          username: "admin",
          password: "123"
        },
        {
          name: "菜单管理员",
          username: "MenuManager",
          password: "123456"
        },
        {
          name: "无权限用户",
          username: "no",
          password: "123456"
        }
      ],
      // 表单
      formLogin: {
        username: "admin",
        password: "",
        uuid: "",
        code: ""
      },
      // 校验
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  mounted() {
    // 初始化例子插件
    particlesJS("login", config);
  },
  beforeDestroy() {
    // 销毁 particlesJS
    // thanks https://github.com/d2-projects/d2-admin/issues/65
    // ref https://github.com/VincentGarreau/particles.js/issues/63
    if (pJSDom && pJSDom.length > 0) {
      pJSDom[0].pJS.fn.vendors.destroypJS();
      pJSDom = [];
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    ...mapActions("d2admin/account", ["login"]),
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },
    getCode() {
      getCodeImg().then(response => {
        this.codeUrl = "data:image/gif;base64," + response.captcha;
        this.formLogin.uuid = response.uuid;
      });
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 登录
          this.login({
            vm: this,
            username: this.formLogin.username,
            password: this.formLogin.password,
            verCode: this.formLogin.code,
            uuid: this.formLogin.uuid
          });
        } else {
          // 登录表单校验失败
          this.$message.error("表单校验失败");
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
